export default class DashboardTrimestralResponse {
  constructor(public data?: Trimestre[]) {} 
  }
  
  class Trimestre {
    constructor(
      public nombrePeriodo?: string,
      public monto?: number,
      public secuencia?: number
    ) {}
  }
  
  export { DashboardTrimestralResponse, Trimestre };
  